<template>
  <Form :errorMsg="errorMsg">
    <template v-slot:Title>
      Préférences
    </template>

    <template v-slot:Content >
      <Tabs
        :tabs="tabs"
        :current="tabDisplayedId"
        @changeDisplayedTab="changeDisplayedTab"
      ></Tabs>

      <TabContent
        id="general"
        name="Informations générales"
        :current="tabDisplayedId"
        @createTab="registerTab"
      >
        <h3>Extensions / Bookmark</h3>
        <a :href="bookmarkletAdd">bookmarklet add</a>
        Drag and drop this link to your toolbar browser. To bookmark page, select some text in page, and click on it, in your toolbar browser.

      </TabContent>

      <TabContent
        id="preferences"
        name="Préférences du site"
        :current="tabDisplayedId"
        @createTab="registerTab"
      >
        <LangEditor></LangEditor>
        <BooleanEditor fieldname="collectactionhistory"></BooleanEditor>
        <MaxResultEditor></MaxResultEditor>
        <MaxTagInCloudEditor></MaxTagInCloudEditor>
      </TabContent>

      <TabContent
        id="actions"
        name="Actions"
        :current="tabDisplayedId"
        @createTab="registerTab"
      >
        <Actions :actions="user.actions"></Actions>
      </TabContent>

      <TabContent
        id="tags"
        name="Édition des tags"
        :current="tabDisplayedId"
        @createTab="registerTab"
      >
        <TagsEditor></TagsEditor>
      </TabContent>
    </template>
  </Form>
</template>

<script>
// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Form from '@/components/common/Form'
import Tabs from '@/components/common/Tabs'
import TabContent from '@/components/common/TabContent'
import LangEditor from '@/components/preferences/LangEditor'
import MaxResultEditor from '@/components/preferences/MaxResultEditor'
import MaxTagInCloudEditor from '@/components/preferences/MaxTagInCloudEditor'
import Actions from '@/components/preferences/Actions'
import TagsEditor from '@/components/preferences/TagsEditor'
import BooleanEditor from '@/components/preferences/BooleanEditor'

@Component({
  name: 'Preferences',
  components: {
    Actions,
    Form,
    LangEditor,
    MaxResultEditor,
    MaxTagInCloudEditor,
    Tabs,
    TabContent,
    TagsEditor,
    BooleanEditor
  }
})
class Preferences extends Vue {
  errorMsg = ''
  bookmarkletAdd = `javascript:document.location='${location.protocol}//${location.host}/edit/new?uri='+encodeURIComponent(location.href)+'&description='+encodeURIComponent(document.title + '\\n' + (document.getSelection() || ''))`
  tabDisplayedId = 'general'
  tabs = []


  load() {
    this.$fetch.get('/users/current').then(
      (user) => {
        console.log('ok', user)
        // on force la mise a jour du user, pour avoir les dernieres infos
        this.saveUser(user)
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }

  changeDisplayedTab(tabId) {
    this.tabDisplayedId = tabId;
  }

  beforeMount() {
    console.log('beforeMounted preference')
    this.load()
  }

  registerTab(i, y) {
    this.tabs.push({
      id: i,
      name: y
    })
  }
}

export default Preferences
</script>

<style lang="less">
.bow-form-wrapper {
  background-color: white;
}
</style>
